export const ADMIN_ROUTES = ['/service-manager/containers', '/service-manager/clients', '/service-manager/user-manager'];
export const MAX_TABLE_HEIGHT = '90%'
